<template>
  <div class="content">
    <div class="down-page">
      <div class="body">
        <div class="card-group" v-for="(item, index) in list" :key="index">
          <div class="card-content">
            <div class="info-left">
              <el-checkbox class="check-box" v-model="item.checked"></el-checkbox>
              <img class="imgS" src="@static/images/product/pack.png" v-if="item.type==2" />
              <fileType className="imgS" :url="item.url" v-else></fileType>
              <div class="card-title" @click="handleExpand(item, index)">
                <span class="title-text">{{ item.name }}</span>
                <span v-if="item.type==2">(共{{item.fileNum}}个文件)</span></div>
              <div class="arrow-icon" v-if="item.type == 2" :class="{'el-icon-arrow-up': item.arrowFlag, 'el-icon-arrow-down': !item.arrowFlag}"
                @click="handleExpand(item, index)"></div>
            </div>
            <div class="info-right">
              <div class="download-info">
                <div class="file-size">{{ item.size }}</div>
                <el-divider direction="vertical"></el-divider>
                <div>{{ item.createTime | timeNum(10) }}</div>
              </div>
              <div class="btn clearfix">
                <el-button class="xzbtn" type="warning" v-if="item.url||item.type==2" @click="downloadFile(item)">下载</el-button>
                <el-button class="ylbtn" v-if="checkFileType(item.url,['.pdf','.png','.jpg'])" type="warning" @click="lookPDF(item.url)">预览</el-button>
              </div>
            </div>
          </div>
          <el-collapse-transition v-if="item.type == 2">
            <div class="card-body clearfix" v-show="item.arrowFlag">
              <div class="info-list" v-for="(info, i) in item.children" :key="i">
                <div class="left">
                  <fileType className="info-img" :url="info.url"></fileType>
                  <div class="info-title">{{ info.name }}</div>
                </div>
                <div class="right">
                  <div class="ylbtn" @click="lookPDF(info.url)" v-if="checkFileType(info.url,['.pdf','.png','.jpg'])">预览</div>
                  <el-divider direction="vertical" v-if="checkFileType(info.url,['.pdf','.png','.jpg'])"></el-divider>
                  <div class="xztxtbtn" @click="downloadFile(info)" v-if="info.url">下载</div>
                </div>
              </div>
            </div>
          </el-collapse-transition>
        </div>
      </div>
      <div class="footer clearfix" v-if="list&&list.length">
        <div class="left">
          <el-checkbox class="all-select-box" v-model="checkedAll" @change="selelctAll"></el-checkbox>
          <div class="all-select">全选</div>
        </div>
        <div class="right">
          <div class="right-info">已经选择<span class="num-color">{{selelctNum}}</span>项</div>
          <el-button type="warning" class="ljxzbtn" @click="downloadSelect">立即下载</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import fileType from "./fileType";
export default {
  props: {
    list:null,
    themeActive: Number,
    activeNum: Number
  },
  data: () => ({
    checkedAll: false,
  }),
  watch:{
    list(){
      this.checkedAll = false;
    }
  },
  computed: {
    selelctNum(){
      let i = 0;
      this.list&&this.list.forEach(item=>{
        if(item.checked){
          i++
        }
      });
      return i;
    }
  },
  components: {fileType},
  created() {},
  methods: {
    lookPDF(url){
      window.open(url)
    },
    // 选择全部
    selelctAll(){
      this.list.forEach(item=>{
        item.checked = this.checkedAll
      })
    },
    // 下载单个文件
    downloadFile(item) {
      if(item.type == 2){
        const list = [
          {
            type: item.type,
            fileId: item.fileId,
            productId: item.productId,
          }
        ];
        this.$tools.daochu('/master/information/downloadFile',{list},'put');
      }else if(item.url) {
        this.$tools.daochu2(item.url)
      }
    },
    // 下载选中的文件
    downloadSelect(){
      if(this.list.length == 0){
        this.$notice.msg("请选择至少一个文件");
        return;
      }
      const list = [];
      this.list.forEach(item=>{
        if(item.checked){
          list.push({
            type: item.type,
            fileId: item.fileId,
            productId: item.productId,
          });
        }
      })
      this.$tools.daochu('/master/information/downloadFile',{list},'put');
    },
    // 验证文件类型
    checkFileType(url, type) {
      if(!url) {
        return false;
      }
      url = url.toLowerCase()
      if(typeof type == "string" && url.includes(type)){
        return true;
      }
      if(typeof type == "object"){
        const fileType = url.substring(url.lastIndexOf("\."));
        if(type.includes(fileType)){
          return true;
        }
      }
      return false;
    },
    // 展开文件明细
    handleExpand(item, index) {
      if(item.type==1){
        return;
      }
      if(item.children&&item.children.length){
        item.arrowFlag = !item.arrowFlag;
        this.$forceUpdate();
        return;
      }
      this.$http({
        url:'/master/information/queryFiles',
        type:'get',
        params: {
          productId:item.productId
        }
      }).then((res)=>{
        item.children = res.data;
        item.arrowFlag = true;
        this.$forceUpdate();
      })
      
      
    },
    handleSizeChange() {},
    handleCurrentChange() {}
  }
};
</script>
<style lang="scss" scoped>
@import "./productDownload.scss";
</style>
